import {createContext} from "react";
import {ThemeName} from "../themes";

export type ThemeContextType = {
    themeName: ThemeName,
    setThemeByName: (themeName: ThemeName) => void
}

export const DefaultContext: ThemeContextType = {
    themeName: 'default',
    setThemeByName: () => {},
}

export const ThemeContext = createContext<ThemeContextType>(DefaultContext)
